import { AlertCircle } from "lucide-react";

import Callout from "@/components/ui/Callout";
import { MODULE_STATE } from "@/permissions/modules";
import useModuleAccess from "@/hooks/useModuleAccess";

/**
 * The one banner for "entitled, but switched off fleet-wide".
 *
 * Renders **only** in the unavailable state. Available renders nothing, and so
 * does not-entitled: a tenant who never bought the module is not waiting for it
 * to come back, and a sentence about an outage in a tool they do not have is
 * noise. Their surface is gone already — see `ModuleGate`.
 *
 * Place it once per page or panel, at the top, above the controls it explains.
 * `ModuleGate` deliberately renders no prose of its own, so this is where the
 * sentence lives. Two of these on one screen is the bug it was written to stop.
 *
 * @param {string} module   a value from MODULES
 * @param {string} [suffix] one clause about what still works here, e.g.
 *                          "Strings already generated are shown below."
 * @param {string} [className]
 */
export const ModuleUnavailableNotice = ({ module, suffix = "", className = "" }) => {
  const { state, message } = useModuleAccess(module);

  if (state !== MODULE_STATE.UNAVAILABLE) return null;

  return (
    <Callout role="status" icon={AlertCircle} className={`rounded-lg px-3 py-2.5 ${className}`} iconClassName="h-[15px] w-[15px]">
      {message}
      {suffix ? ` ${suffix}` : ""}
    </Callout>
  );
};

export default ModuleUnavailableNotice;
